export default class GlobalFunctions {
  static setReadOnly(shouldBeReadOnly) {
    window.readOnly = false;
    if (shouldBeReadOnly) {
      document.querySelectorAll('input, select:not([id^=selectLocale]), button, textarea, checkbox').forEach(elem => elem.disabled = true);
      window.readOnly = true;
    }
  }

  static acceptPageLeave(object, confirmText) {
    if (window.readOnly) {
      return true;
    }

    if (localStorage.getItem('loadStatus') === 'loading') {
      return true;
    }

    if (object === null) {
      return true;
    }

    if (JSON.stringify(object) !== localStorage.getItem('startingObject')) {
      const deleteRemarks = confirm(confirmText);
      if (deleteRemarks === true) {
        return false;
      }
    }

    return true;
  }
}
